/**
 * Created by Administrator on 2018/10/9.
 */
"use strict" ;
export default{
  install(Vue,options){
    Vue.prototype.filterArray=(searchArray,filedArray,text)=>{
      var _searchText = text + '';
      var resultArr = [];
      if(_searchText == '')return resultArr;
      for (var j = 0; j < searchArray.length; ++j) {
        var item = searchArray[j];
        var _isFind = false;
        for (var i = 0; i < 2; ++i) {
          var _srcText = item[filedArray[i]];
          _searchText = _searchText.toLowerCase();
          _srcText = _srcText.toLowerCase();
          if (!_isFind && _srcText.indexOf(_searchText) >= 0) {
            resultArr.push(item);
            _isFind = true;
          }
        }
      }
      return resultArr;
    } ;

    Vue.prototype.orderBy=(array,key)=>{
      let sortBy = function(attr,rev){
        //第二个参数没有传递 默认升序排列
        if(rev ==  undefined){
          rev = 1;
        }else{
          rev = (rev) ? 1 : -1;
        }

        return function(a,b){
          a = a[attr];
          b = b[attr];
          if(a < b){
            return rev * -1;
          }
          if(a > b){
            return rev * 1;
          }
          return 0;
        }
      };


      return array.sort(sortBy(key,false))
    }


  }
}




// WEBPACK FOOTER //
// ./src/service/ServiceFilter.js